import { Injectable, inject } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastController = inject(ToastController);


  public async displaySuccessToast(message: string): Promise<void> {
    const toast = await this.toastController.create({
      header: 'Erfolgreich',
      message: message,
      duration: 3000,
      color: 'success',
      position: 'top',
      icon: 'checkmark-circle-outline',
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  public async displayInfoToast(message: string): Promise<void> {
    const toast = await this.toastController.create({
      header: 'Information',
      message: message,
      duration: 3000,
      color: 'primary',
      position: 'top',
      icon: 'information-circle-outline',
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  public async displayWarningToast(message: string, durationMs = 3000): Promise<void> {
    const toast = await this.toastController.create({
      header: 'Warnung',
      message: message,
      duration: durationMs,
      color: 'warning',
      position: 'top',
      icon: 'warning-outline',
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  public async displayErrorToast(message: string): Promise<void> {
    const toast = await this.toastController.create({
      header: 'Fehler',
      message: message,
      duration: 5000,
      color: 'danger',
      position: 'top',
      icon: 'alert-circle-outline',
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }
}
